import React, { useEffect, useRef } from 'react';
import { AppLocalStorage, AppLocalStorageItems } from '../../helpers/localStorageHelper';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { OverlayPanel } from 'primereact/overlaypanel';
import { logoutUser, setUserAuth } from '../../store/auth/authSlice';
import userIcon from '../../assets/images/User-icon.png'
import { AppToast } from '../../lib/toast';


function getProfileImage() {
    let img = AppLocalStorage.getStorageItem(AppLocalStorageItems.ProfilePic)
    if ((img === 'undefined' || !img)) {
        img = userIcon
    }
    return img;
}

const _props = {
    label: ''
}
export function UserProfile(props = _props) {
    const userInfo = useSelector(state => state.auth.userInfo) || {};
    const currentTenant = useSelector(state => state.tenant.currentTenant);
    const op = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const img = getProfileImage()
    const onLogout = () => {
        dispatch(logoutUser()).then((x) => {
            if (x?.payload?.status == 200 && x.payload.data.success) {
                // AppLocalStorage.removeStorageItem(AppLocalStorageItems.Key)
                // AppLocalStorage.removeStorageItem(AppLocalStorageItems.PageStateInformation)
                sessionStorage.clear();
                AppLocalStorage.clearLocalStorage();
                dispatch(setUserAuth({}));
                navigate("/signin", { replace: true })
            }
            else {
                AppToast.Toast.error({
                    title: 'Server Error',
                    message: 'Logout Failed'
                })
            }
        }).catch(() => {
            AppToast.Toast.error({
                title: 'Server Error',
                message: 'Logout Failed'
            })
        })       
    }

    // useEffect(() => {
       
    // },[])


    return <>
        <div className="user_details" >
            <a style={{ cursor: 'pointer' }} onClick={(e) => {
                op.current.toggle(e)
            }} className="d-flex link-dark text-decoration-none aira-arrow" id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false">
                <img src={img} alt="mdo" width="32" height="32" className="rounded-circle" />
                <span className="current_user">
                    <span className="user_name">{userInfo.userName}</span>
                    {/* <span className="user_bio">{userInfo.role}</span> */}
                    <span className="user_bio">{currentTenant?.tenantName}</span>
                </span>
                <span className='logoutDrop'> 
                    {/* <i className={PrimeIcons.SORT_DOWN}></i> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="8.5" height="5.5" viewBox="0 0 8.5 5.5"><path id="Path_11" data-name="Path 11" d="M455.5,182l4,5.5L464,182Z" transform="translate(-455.5 -182)" fill="#908488"/></svg>
                </span>
            </a>
        </div>
        <OverlayPanel ref={op} id="overlay_panel" style={{ width: '223px' }} className="overlaypanel-profile">
            <div className='tenantProfile_box'>
                <div className='tenantProfile_inner'>
                    <div className='tenantProfile_img'>
                        <img src={img} alt="mdo" width="32" height="32" className="rounded-circle" />
                    </div>
                    <div className='tenantProfile_text'>
                        <p>{userInfo.userName}</p>
                        <span>{userInfo.role}</span>
                    </div>
                </div>
                <div className='tenantProfile_client_area'>
                    <div className='tenantProfile_client'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="11.625" viewBox="0 0 15.5 11.625">
                            <g id="people-fill" transform="translate(0 -4.5)">
                                <path id="Path_37626" data-name="Path 37626" d="M6.781,16.125a.949.949,0,0,1-.969-.969c0-.969.969-3.875,4.844-3.875S15.5,14.188,15.5,15.156a.949.949,0,0,1-.969.969Zm3.875-5.812A2.906,2.906,0,1,0,7.75,7.406,2.906,2.906,0,0,0,10.656,10.313Zm-5.6,5.813a2.168,2.168,0,0,1-.209-.969,4.623,4.623,0,0,1,1.875-3.6,6.127,6.127,0,0,0-1.875-.271C.969,11.281,0,14.188,0,15.156a.949.949,0,0,0,.969.969Zm-.694-5.812A2.422,2.422,0,1,0,1.938,7.891,2.422,2.422,0,0,0,4.359,10.313Z" fill="#333" fill-rule="evenodd"/>
                            </g>
                        </svg>
                    {/* <span>Client: </span>  */}
                    </div> 
                    <h5>{currentTenant?.tenantName}</h5>
                </div>
            </div>
            <div style={{ cursor: 'pointer' }} onClick={onLogout} className='profile-item'>  Logout 
                <span className='tenant_logout-arrow'>
                    <svg id="Layer_2" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 2"><path d="m22.707 11.293-7-7a1 1 0 0 0 -1.414 1.414l5.293 5.293h-17.586a1 1 0 0 0 0 2h17.586l-5.293 5.293a1 1 0 1 0 1.414 1.414l7-7a1 1 0 0 0 0-1.414z"/></svg>
                </span>
            </div>
        </OverlayPanel>

        {/* <SessionTimeout logoutHandler={onLogout}/> */}
    </>
}